import React from 'react';

const Checkbox = React.forwardRef(({ id, label, ...props }, ref) => {
  return (
    <div className="flex flex-col space-y-1">
      <div className="flex items-center">
        <div className="inline-flex items-center">
          <label className="flex items-center cursor-pointer relative">
            <input type="checkbox" id={id} ref={ref} {...props} className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border checked:bg-primary checked:bg-primary" />
            <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
            </span>
          </label>
        </div>
        <label htmlFor={id} className="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">
          {label}
        </label>
      </div>
      {/* {error && <p className="text-sm text-red-500">{error}</p>} */}
    </div>
  );
});

// Set a display name for the component (optional but recommended for debugging)
Checkbox.displayName = 'Checkbox';

export default Checkbox;